import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=26d159de&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"
import style0 from "./notices.vue?vue&type=style&index=0&id=26d159de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d159de",
  null
  
)

export default component.exports